// TanStack Query key factory for the Shot Builder feature.
// Centralised so hooks and the WebSocket activity listener invalidate the
// same keys.

export const shotKeys = {
  scenes: (projectId: string) => ["shot-scenes", projectId] as const,
  shot: (shotId: string) => ["shot", shotId] as const,
  assets: (shotId: string) => ["shot-assets", shotId] as const,
  direction: (shotId: string) => ["shot-direction", shotId] as const,
  audit: (shotId: string) => ["shot-audit", shotId] as const,
  nodes: (shotId: string) => ["shot-nodes", shotId] as const,
  node: (shotId: string, nodeKey: string) =>
    ["shot-node", shotId, nodeKey] as const,
  templates: (projectId: string) => ["workflow-templates", projectId] as const,
};
